// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/home-bg-section1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/Images/home-bg-section2.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_container{
    color: #FFFFFF;
}

.home_section1_container{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 500px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0 50px;
    padding-top: 50px;
}

.home_section1{
    display: flex;
    justify-content: space-between;
    padding: 100px 100px  0 0;
}

.home_section1_heading h3{
    font-weight: 700;
    font-size: 48px;
    line-height: 65px;
}

.home_section1_heading h5{
    font-weight: 700;
    font-size: 34px;
    line-height: 51.99px;
}

.home_section1_text{
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    width: 656px;
}

.award_container img{
    height: 179px;
    width: 179px;
    animation: animateImage 3s infinite;
    transition: transform 1s ease;
}

@keyframes animateImage {
    0% {
      transform: scale(1); 
    }
    25% {
      transform: scale(1.2); 
    }
    50% {
      transform: scale(1.4); 
    }
    75% {
      transform: scale(1.2); 
    }
    100% {
      transform: scale(1); 
    }
}


.homeBtn_container{
    width: 180px;
    padding: 40px 0 100px 0;
}

.homeBtn_container a, .homeBtncard_container a, .discovermore_btn a, .home_section4_btn a{
    text-decoration: none;
    color: #FFFFFF;
}

.home_section2_container{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 1400px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    padding: 0 50px;
}

.homeCards_container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 100px;
}

.homeCard1{
    background-color: #FFFFFF;
    border-radius: 15px;
    width: 410px;
    height: 373px; 
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.homeCard1h4{
    color: #000000;
    font-weight: 700;
    font-size: 24px;
    line-height: 36.7px;
    padding-bottom: 10px;
}

.homeCard1p{
    color: #000000;
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
    text-align: center;
    width: 356px;
    height: 96px;  
}

.homeCard2{
    background: radial-gradient(circle at center top, #EAAD11 0%, #5CBF14 25%, #D40E1F 100%);
    border-radius: 15px;
    width: 410px;
    height: 373px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.homeCard2h4 {
    font-weight: 700;
    font-size: 24px;
    line-height: 36.7px;
    padding-bottom: 10px;
}

.homeCard2p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
    text-align: center;
    width: 356px;
    height: 96px;
}

.homeBtncard_container{
    width: 180px;
   padding-top: 50px;
}

.homeSponsors_container{
    padding: 50px 0;
}

.homeSponsors_heading{
    font-weight: 700;
    font-size: 30px;
    line-height: 65px;
    text-align: center;
    margin-bottom: 20px;
}



.homeSponsorsGallery_container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;
    overflow-x: auto; 
    white-space: nowrap; 
    -ms-overflow-style: none; 
    scrollbar-width: none;
}

.homeSponsorsGallery_container::-webkit-scrollbar {
    display: none;
  }

.home_section3_container{
    display: flex;
    margin-top: 130px;
    padding: 0 50px;
    gap: 20px;
}

.home_section3_column1{
    height: 204px;
}

.home_section3_column1h6{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    color:#EAAD11;
}

.home_section3_column1p{
    font-weight: 700;
    font-size: 30px;
    line-height: 50px;
}

.homehr_line{
    width: 271px;
    height: 6px ;
    border-radius: 15px;
    background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);
    border: none;
    margin-top: 10px;
}

.home_section3_column2{
    display: flex;
    gap: 20px;
}

.homeOurThinking_Text{
    width: 339px;
    height: 294px;
}

.homeOurThinking_Text{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.homeOurThinking_Textp{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    width: 339px;
    height: 196px;
}

.discovermore_btn{
    width: 200px;
    height: 52px;
}

.homenet1_img_container{
    position: absolute;
    bottom: -5px;
    left: 0;
}

.home_section4_container{
    background-color:rgb(5, 53, 5) ;
    height: 680px;
    display: flex;
    padding: 70px 50px;
    gap: 60px;
     
}
.home_section4_column1{
    width: 402px;
    height: 154px;
}

.home_section4_column1h6{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    color: #EAAD11;
}

.home_section4_column1p{
    font-weight: 700;
    font-size: 30px;
    line-height: 50px;
}

.home_section4_btn{
    background-color: #5CBF14;
    border-radius: 25px;
    padding: 12px 44px;
    cursor: pointer;
    width: 230px;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

}

.home_section4_btn:hover{
    background-color: black;
    transition: all 0.7s ease-in-out;
}

.home_section4_btn_p{
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
}

.home_section4_column2{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}
.home_section4_column2_part1, .home_section4_column2_part2{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    
}

.soluIcon_common{
    width: 40.18px;
    height: 35.18px;
}

.solutionsHead_common{
    font-weight: 700;
   font-size: 24px;
   line-height: 33.1px;
}

.solutionsText_common{
    font-weight: 400px;
    font-size: 16px;
    line-height: 24.46px;
    width: 320px;
    height: 96px;
}

.solutions_readmore_hr_container{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.solutions_readmore{
    font-weight: 500;
    font-size: 16px;
    line-height: 24.46px;
    color: #EAAD11;
    width: 78px;
    /* height: 24px; */
    padding-top: 10px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: border-bottom 0.7s ease;
}

.solutions_readmore:hover{
    color: #5CBF14;
    border-bottom:2px solid #EAAD11;
}

.healthsolu_container{
    display: flex;
    width: 377px;
    height: 181px;
    gap: 10px;
}

.healthsolu_container a{
    text-decoration: none;
}


/* responsiveness starts here */

@media screen and (max-width: 1050px){
    .home_section1{
        padding: 100px 0  0 0;
    }

    .home_section1_heading h3{
        font-size: 40px;

    }
    
    .home_section1_heading h5{
        font-size: 30px;
        padding-bottom: 10px;
    }
    
    .home_section1_text{
        font-size: 15px;
        width: 640px;
    }


    .homeCard1{
        width: 320px;
        height: 300px; 
    }
    
    .homeCard1h4{
        font-size: 22px;
    }
    
    .homeCard1p{
        font-size: 14px;
        width:270px;
    }

    .homeCard2{
        width: 320px;
        height: 300px; 
    }
    
    .homeCard2h4 {
        font-size: 22px;
    }
    
    .homeCard2p {
        font-size: 14px;
        width:270px;
    }

    .homeBtncard_container{
        width: 165px;
    }

    .homeSponsorsGallery_icon{
        width: 90px;
        height: 60px;
    }

    .home_section3_container{
        padding: 0;
   
    }
    
    .home_section3_column1p{
        font-size: 22px;
    }
    
    .homehr_line{
        width: 180px;
    
    }
    
    
    .homeOurThinking_Text{
        width: 320px;
    }
    
    .homeOurThinking_Textp{
        font-size: 18px;
        line-height: 27.52px;
        width: 339px;
        height: 196px;
    }
    
    .discovermore_btn{
        width: 200px;
        height: 52px;
    }
    
    .homenet1_img_container{
        position: absolute;
        bottom: -5px;
        left: 0;
    }

    .home_section4_container{
        padding: 70px 40px;
        gap: 30px;
         
    }
    
    .home_section4_btn{
        padding: 12px 44px;
        width: 170px;
    }
    
    .home_section4_btn_p{
        font-size: 11px;
    }
    
    .home_section4_column1h6{
    font-size: 16px;
    }
    
    .home_section4_column1p{
        font-size:18px;
    }
    
    
    .soluIcon_common{
        width: 35px;
        height: 35px;
    }
    
    .solutionsHead_common{
       font-size: 22px;
    }
    
    .solutionsText_common{
        font-size: 14px;
        width: 300px;

    }
    
    .solutions_readmore{
        font-size: 14px;
    }
    
    .healthsolu_container{
        display: flex;
        width: 377px;
        height: 181px;
        gap: 10px;
    }
    
}

@media screen and (max-width: 900px){
    .home_section1_heading h3{
        font-size: 28px;

    }
    
    .home_section1_heading h5{
        font-size: 20px;
        padding-bottom: 10px;
    }
    
    .home_section1_text{
        font-size: 15px;
        width: 450px;
    }
    
    .award_container img{
        height: 169px;
        width: 169px;
    }
    
    .homeBtn_container{
        width: 170px;
        padding: 30px 0 80px 0;
    }

    .homeCard1{
        width: 210px;
        height: 290px; 
    }
    
    .homeCard1h4{
        font-size: 15px;
    }
    
    .homeCard1p{
        font-size: 11px;
        width:180px;
    }

    .homeCard2{
        width: 210px;
        height: 290px; 
    }
    
    .homeCard2h4 {
        font-size: 15px;
    }
    
    .homeCard2p {
        font-size: 11px;
        width:180px;
    }

    .homeSponsorsGallery_icon1{
        width: 30px;
        height: 30px;
    }

    .homeSponsorsGallery_icon{
        width: 60px;
        height: 60px;
    }
 
    .home_section3_column1p{
        font-size: 16px;
    }
    
    .homehr_line{
        width: 150px;
    
    }
    
    .homeOurThinking_Textp{
        font-size: 13px;
        width: 210px;

    }
    
    .discovermore_btn{
        width: 170px;
        height: 40px;
    }
    
    .homenet1_img_container{
        position: absolute;
        bottom: -5px;
        left: 0;
    }

    .homenet1_img_container img{
        width: 750px;
    }

    .home_section4_container{
        padding: 70px 20px;
        gap: 20px
         
    }
    
    .home_section4_column1h6{
        font-size: 14px;
    }
    
    .home_section4_column1p{
        font-size:13px;
    }

    .home_section4_btn{
        padding: 8px 24px;
        width: 130px;
    }
    
    .soluIcon_common{
        width: 25px;
        height: 35px;
    }
    
    .solutionsHead_common{
       font-size: 19px;
    }
    
    .solutionsText_common{
        font-size: 12px;
        width: 230px;

    }
    
    .solutions_readmore{
        font-size: 12px;
    }

    .healthsolu_container{
        display: flex;
        width: 260px;
        height: 181px;
        gap: 10px;
    }
    
}


@media screen and (max-width: 500px){

    .award_container{
        margin: auto;
    }

    .home_section1_container{
        padding: 40px 10px 0 10px;
    }

    .home_section1_container{
        height: 670px;
    }

    .home_section1{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding:30px  30px;
    }
    
     .home_section1_heading h3{
        font-size: 32px;
        font-weight: 700;
        line-height: 65px;

    }
    
    .home_section1_heading h5{
        font-size: 22px;
        font-weight: 700;
        line-height: 34px;
        padding-bottom: 10px;

    }
    
    .home_section1_text{
        width: 380px;
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
    }
    
    .award_container img{
        height: 179px;
        width: 179px;
    }

    .home_section2_container{
        height: 2500px;
        padding: 0 20px;

    }


    .homeCards_container{
        display: flex;
        flex-direction: column;
        padding-top: 20px;
    }

    .homeSponsors_container{
        padding-top:0;
    }

    .homeCard1{
        width:100%;
        height: 350px; 
    }
    
    .homeCard1h4{
        font-size: 24px;
    }
    
    .homeCard1p{
        font-size: 16px;
        line-height: 24.46px;
        text-align: center;
        width: 300px;
    }
    
    .homeCard2{
        width:100%;
        height: 350px;
    }
    
    .homeCard2h4 {
        font-size: 24px;
    }
    
    .homeCard2p {
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        text-align: center;
        width: 300px;
    }
    
    .homeBtncard_container{
        width: 180px;
       padding-top: 50px;
    }

    .homeSponsors_container{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .homeSponsorsGallery_container{
        padding-left: 27rem;
    }

   

    .home_section3_container{
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        margin-top: 0;
        padding: 20px 0 ;
        gap: 20px;
    
    }

    .home_section3_column1{
        padding-top: 20px;
    }

    .home_section3_column1h6{
        font-size: 15px;
    }

    .home_section3_column1p{
        font-size: 24px;
    }

    .homehr_line{
        width: 251px;
        margin-top: 0;
    }

    .home_section3_column2{
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;
    }

    .homeOurThinking_Pics img{
        width: 100%;
    }


    .homeOurThinking_Text{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .homeOurThinking_Textp{
        font-size: 18px;
        line-height: 27.52px;
        width: 339px;
        height: 196px;
        text-align: center;
        padding-top: 10px;
    }

    .discovermore_btn{
        width: 200px;
        height: 52px;
        margin: auto;
    }

    .homenet1_img_container{
        position: absolute;
        bottom: -5px;
        left: 0;
    }

    .homenet1_img_container img{
        width: 100%;
    }

    .home_section4_container{
        height: 1500px;
        display: flex;
        flex-direction: column;
        padding: 40px 20px;
        gap: 30px;
        background-color: rgb(5, 53, 5);
         
    }
    .home_section4_column1{
        width: 100%;
        height: 154px;
    }
    
    .home_section4_column1h6{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        color: #EAAD11;
    }
    
    .home_section4_column1p{
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
        padding-bottom: 20px;
    }

    .home_section4_hrline{
        width: 170px;
    }
    
    .home_section4_btn{
        background-color: #5CBF14;
        border-radius: 25px;
        padding: 12px 44px;
        cursor: pointer;
        width: 200px;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    
    }
    
    .home_section4_btn_p{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
    }
    
    .home_section4_column2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 50px;
    }
    .home_section4_column2_part1, .home_section4_column2_part2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        width: 100%;
        
    }
    
    .soluIcon_common{
        width: 40.18px;
        height: 35.18px;
    }
    
    .solutionsHead_common{
        font-weight: 700;
       font-size: 24px;
       line-height: 33.1px;
    }
    
    .solutionsText_common{
        font-weight: 400px;
        font-size: 16px;
        line-height: 24.46px;
        width: 100%;
        height: 96px;
    }
    
    .solutions_readmore{
        font-weight: 500;
        font-size: 16px;
        line-height: 24.46px;
        color: #EAAD11;
        width: 78px;
        /* height: 24px; */
        padding-top: 10px;
    }
    
    .healthsolu_container{
        display: flex;
        width: 100%;
        height: 181px;
        gap: 10px;
    }
    

    
}

@media screen and (max-width: 440px){
    .home_section1{
        padding:30px  20px;
    }

    .home_section1_heading h3{
        font-size: 25px;
    }
    
    .home_section1_heading h5{
        font-size: 19px;
        font-weight: 700;
        line-height: 34px;
    }
    
    .home_section1_text{
        font-size: 14px;
        width: 300px;
    }


    .homeOurThinking_Textp{
        font-size: 16px;
        width: 300px;
    }


    .home_section4_column1h6{
        font-size: 15px;
    }
    
    .home_section4_column1p{
        font-size: 20px;
    }
    
    .home_section4_btn{
        padding: 10px 32px;
        width: 190px;
    }
    
    .home_section4_btn_p{
        font-size: 14px;
    }

    .home_section4_column2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 50px;
    }
    .home_section4_column2_part1, .home_section4_column2_part2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        
    }
    
    
    .soluIcon_common{
        width: 30.18px;
        height: 33.18px;
    }
    
    .solutionsHead_common{
       font-size: 20px;
    }
    
    .solutionsText_common{
        font-size: 12px;
    }
    
    .solutions_readmore{
        font-size: 14px;
    }
    


   
}

@media screen and (max-width: 380px){
  

    .home_section1_heading h3{
        font-size: 20px;
    }
    
    .home_section1_heading h5{
        font-size: 15px;
        font-weight: 700;
        line-height: 34px;
    }
    
    .home_section1_text{
        width: 310px;
        font-size: 12px;
    }

    .home_section2_container{
        height: 2430px;
    }

    .homeCard1h4, .homeCard2h4{
        font-size: 22px;
    }
    
    .homeCard1p, .homeCard2p{
        font-size: 14px;
        line-height: 24.46px;
        text-align: center;
        width: 240px;
    }

    .homeSponsorsGallery_container{
        padding-left: 31rem;
    }


    .home_section3_column1h6{
        font-size: 12px;
    }

    .home_section3_column1p{
        font-size: 22px;
    }

    .homehr_line{
        width: 221px;
        margin-top: 0;
    }

    
}

@media screen and (max-width: 330px){
  
    .home_section1{
        padding:30px  10px;
    }
    .home_section1_heading h3{
        font-size: 17px;
    }
    
    .home_section1_heading h5{
        font-size: 12px;
        font-weight: 700;
        line-height: 34px;
    }
    
    .home_section1_text{
        width: 280px;
        font-size: 10px;
    }

    .homeCard1h4, .homeCard2h4{
        font-size: 20px;
    }
    
    .homeCard1p, .homeCard2p{
        font-size: 13px;
        line-height: 24.46px;
        text-align: center;
        width: 200px;
    }

    .homeSponsorsGallery_container{
        padding-left: 31rem;
        width: 100%;
        
        
    }


    .home_section3_column1h6{
        font-size: 11px;
    }

    .home_section3_column1p{
        font-size: 19px;
    }

    .homehr_line{
        width: 200px;
        margin-top: 0;
    }

    .homeOurThinking_Textp{
        font-size: 15px;
        width: 260px;
    }

    .discovermore_btn{
        width: 190px;
        height: 52px;
        margin: auto 30px auto ;
    }
    
    .home_section4_btn{
        padding: 10px 32px;
        width: 170px;
    }
    
    .home_section4_btn_p{
        font-size: 12px;
    }
    
    
    .soluIcon_common{
        width: 28.18px;
        height: 30.18px;
    }
    
    .solutionsHead_common{
       font-size: 18px;
    }
    
    .solutionsText_common{
        font-size: 12px;
        margin-bottom: 10px;
        
    }
    
    .solutions_readmore{
        font-size: 12px;
    }
    
  
}`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,yDAA8D;IAC9D,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI;MACE,mBAAmB;IACrB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,mBAAmB;IACrB;AACJ;;;AAGA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yDAA8D;IAC9D,cAAc;IACd,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wFAAwF;IACxF,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;GACb,iBAAiB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,aAAa;EACf;;AAEF;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,SAAS;;AAEb;AACA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;;AAGvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;GACjB,eAAe;GACf,mBAAmB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;;AAGA,+BAA+B;;AAE/B;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;;IAEd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;;IAEhB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,OAAO;IACX;;IAEA;QACI,kBAAkB;QAClB,SAAS;;IAEb;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;IACA,eAAe;IACf;;IAEA;QACI,cAAc;IAClB;;;IAGA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;OACG,eAAe;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;;IAEhB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,aAAa;QACb,SAAS;IACb;;AAEJ;;AAEA;IACI;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,eAAe;QACf,YAAY;;IAEhB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,OAAO;IACX;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB;;IAEJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;OACG,eAAe;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;;IAEhB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,aAAa;QACb,SAAS;IACb;;AAEJ;;;AAGA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;IACtB;;KAEC;QACG,eAAe;QACf,gBAAgB;QAChB,iBAAiB;;IAErB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;;IAExB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;;IAEnB;;;IAGA;QACI,aAAa;QACb,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,YAAY;OACb,iBAAiB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;;;IAIA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,gBAAgB;QAChB,SAAS;;IAEb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,OAAO;IACX;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;QACT,+BAA+B;;IAEnC;IACA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;IAEvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,WAAW;;IAEf;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,gBAAgB;OACjB,eAAe;OACf,mBAAmB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,aAAa;QACb,SAAS;IACb;;;;AAIJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;;IAEb;;;IAGA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;OACG,eAAe;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;;;AAKJ;;AAEA;;;IAGI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;;AAGJ;;AAEA;;IAEI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,WAAW;;;IAGf;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;OACG,eAAe;IAClB;;IAEA;QACI,eAAe;QACf,mBAAmB;;IAEvB;;IAEA;QACI,eAAe;IACnB;;;AAGJ","sourcesContent":[".home_container{\n    color: #FFFFFF;\n}\n\n.home_section1_container{\n    background-image: url('../Assets/Images/home-bg-section1.svg');\n    height: 500px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    padding: 0 50px;\n    padding-top: 50px;\n}\n\n.home_section1{\n    display: flex;\n    justify-content: space-between;\n    padding: 100px 100px  0 0;\n}\n\n.home_section1_heading h3{\n    font-weight: 700;\n    font-size: 48px;\n    line-height: 65px;\n}\n\n.home_section1_heading h5{\n    font-weight: 700;\n    font-size: 34px;\n    line-height: 51.99px;\n}\n\n.home_section1_text{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 30px;\n    width: 656px;\n}\n\n.award_container img{\n    height: 179px;\n    width: 179px;\n    animation: animateImage 3s infinite;\n    transition: transform 1s ease;\n}\n\n@keyframes animateImage {\n    0% {\n      transform: scale(1); \n    }\n    25% {\n      transform: scale(1.2); \n    }\n    50% {\n      transform: scale(1.4); \n    }\n    75% {\n      transform: scale(1.2); \n    }\n    100% {\n      transform: scale(1); \n    }\n}\n\n\n.homeBtn_container{\n    width: 180px;\n    padding: 40px 0 100px 0;\n}\n\n.homeBtn_container a, .homeBtncard_container a, .discovermore_btn a, .home_section4_btn a{\n    text-decoration: none;\n    color: #FFFFFF;\n}\n\n.home_section2_container{\n    background-image: url('../Assets/Images/home-bg-section2.svg');\n    height: 1400px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    position: relative;\n    padding: 0 50px;\n}\n\n.homeCards_container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 100px;\n}\n\n.homeCard1{\n    background-color: #FFFFFF;\n    border-radius: 15px;\n    width: 410px;\n    height: 373px; \n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.homeCard1h4{\n    color: #000000;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 36.7px;\n    padding-bottom: 10px;\n}\n\n.homeCard1p{\n    color: #000000;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n    text-align: center;\n    width: 356px;\n    height: 96px;  \n}\n\n.homeCard2{\n    background: radial-gradient(circle at center top, #EAAD11 0%, #5CBF14 25%, #D40E1F 100%);\n    border-radius: 15px;\n    width: 410px;\n    height: 373px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.homeCard2h4 {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 36.7px;\n    padding-bottom: 10px;\n}\n\n.homeCard2p {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n    text-align: center;\n    width: 356px;\n    height: 96px;\n}\n\n.homeBtncard_container{\n    width: 180px;\n   padding-top: 50px;\n}\n\n.homeSponsors_container{\n    padding: 50px 0;\n}\n\n.homeSponsors_heading{\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 65px;\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n\n\n.homeSponsorsGallery_container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    overflow-x: auto; \n    white-space: nowrap; \n    -ms-overflow-style: none; \n    scrollbar-width: none;\n}\n\n.homeSponsorsGallery_container::-webkit-scrollbar {\n    display: none;\n  }\n\n.home_section3_container{\n    display: flex;\n    margin-top: 130px;\n    padding: 0 50px;\n    gap: 20px;\n}\n\n.home_section3_column1{\n    height: 204px;\n}\n\n.home_section3_column1h6{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    color:#EAAD11;\n}\n\n.home_section3_column1p{\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 50px;\n}\n\n.homehr_line{\n    width: 271px;\n    height: 6px ;\n    border-radius: 15px;\n    background: radial-gradient(circle, #5CBF14 0%, #EAAD11 100%);\n    border: none;\n    margin-top: 10px;\n}\n\n.home_section3_column2{\n    display: flex;\n    gap: 20px;\n}\n\n.homeOurThinking_Text{\n    width: 339px;\n    height: 294px;\n}\n\n.homeOurThinking_Text{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.homeOurThinking_Textp{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    width: 339px;\n    height: 196px;\n}\n\n.discovermore_btn{\n    width: 200px;\n    height: 52px;\n}\n\n.homenet1_img_container{\n    position: absolute;\n    bottom: -5px;\n    left: 0;\n}\n\n.home_section4_container{\n    background-color:rgb(5, 53, 5) ;\n    height: 680px;\n    display: flex;\n    padding: 70px 50px;\n    gap: 60px;\n     \n}\n.home_section4_column1{\n    width: 402px;\n    height: 154px;\n}\n\n.home_section4_column1h6{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    color: #EAAD11;\n}\n\n.home_section4_column1p{\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 50px;\n}\n\n.home_section4_btn{\n    background-color: #5CBF14;\n    border-radius: 25px;\n    padding: 12px 44px;\n    cursor: pointer;\n    width: 230px;\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.home_section4_btn:hover{\n    background-color: black;\n    transition: all 0.7s ease-in-out;\n}\n\n.home_section4_btn_p{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n}\n\n.home_section4_column2{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n.home_section4_column2_part1, .home_section4_column2_part2{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    \n}\n\n.soluIcon_common{\n    width: 40.18px;\n    height: 35.18px;\n}\n\n.solutionsHead_common{\n    font-weight: 700;\n   font-size: 24px;\n   line-height: 33.1px;\n}\n\n.solutionsText_common{\n    font-weight: 400px;\n    font-size: 16px;\n    line-height: 24.46px;\n    width: 320px;\n    height: 96px;\n}\n\n.solutions_readmore_hr_container{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.solutions_readmore{\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24.46px;\n    color: #EAAD11;\n    width: 78px;\n    /* height: 24px; */\n    padding-top: 10px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n    transition: border-bottom 0.7s ease;\n}\n\n.solutions_readmore:hover{\n    color: #5CBF14;\n    border-bottom:2px solid #EAAD11;\n}\n\n.healthsolu_container{\n    display: flex;\n    width: 377px;\n    height: 181px;\n    gap: 10px;\n}\n\n.healthsolu_container a{\n    text-decoration: none;\n}\n\n\n/* responsiveness starts here */\n\n@media screen and (max-width: 1050px){\n    .home_section1{\n        padding: 100px 0  0 0;\n    }\n\n    .home_section1_heading h3{\n        font-size: 40px;\n\n    }\n    \n    .home_section1_heading h5{\n        font-size: 30px;\n        padding-bottom: 10px;\n    }\n    \n    .home_section1_text{\n        font-size: 15px;\n        width: 640px;\n    }\n\n\n    .homeCard1{\n        width: 320px;\n        height: 300px; \n    }\n    \n    .homeCard1h4{\n        font-size: 22px;\n    }\n    \n    .homeCard1p{\n        font-size: 14px;\n        width:270px;\n    }\n\n    .homeCard2{\n        width: 320px;\n        height: 300px; \n    }\n    \n    .homeCard2h4 {\n        font-size: 22px;\n    }\n    \n    .homeCard2p {\n        font-size: 14px;\n        width:270px;\n    }\n\n    .homeBtncard_container{\n        width: 165px;\n    }\n\n    .homeSponsorsGallery_icon{\n        width: 90px;\n        height: 60px;\n    }\n\n    .home_section3_container{\n        padding: 0;\n   \n    }\n    \n    .home_section3_column1p{\n        font-size: 22px;\n    }\n    \n    .homehr_line{\n        width: 180px;\n    \n    }\n    \n    \n    .homeOurThinking_Text{\n        width: 320px;\n    }\n    \n    .homeOurThinking_Textp{\n        font-size: 18px;\n        line-height: 27.52px;\n        width: 339px;\n        height: 196px;\n    }\n    \n    .discovermore_btn{\n        width: 200px;\n        height: 52px;\n    }\n    \n    .homenet1_img_container{\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n    }\n\n    .home_section4_container{\n        padding: 70px 40px;\n        gap: 30px;\n         \n    }\n    \n    .home_section4_btn{\n        padding: 12px 44px;\n        width: 170px;\n    }\n    \n    .home_section4_btn_p{\n        font-size: 11px;\n    }\n    \n    .home_section4_column1h6{\n    font-size: 16px;\n    }\n    \n    .home_section4_column1p{\n        font-size:18px;\n    }\n    \n    \n    .soluIcon_common{\n        width: 35px;\n        height: 35px;\n    }\n    \n    .solutionsHead_common{\n       font-size: 22px;\n    }\n    \n    .solutionsText_common{\n        font-size: 14px;\n        width: 300px;\n\n    }\n    \n    .solutions_readmore{\n        font-size: 14px;\n    }\n    \n    .healthsolu_container{\n        display: flex;\n        width: 377px;\n        height: 181px;\n        gap: 10px;\n    }\n    \n}\n\n@media screen and (max-width: 900px){\n    .home_section1_heading h3{\n        font-size: 28px;\n\n    }\n    \n    .home_section1_heading h5{\n        font-size: 20px;\n        padding-bottom: 10px;\n    }\n    \n    .home_section1_text{\n        font-size: 15px;\n        width: 450px;\n    }\n    \n    .award_container img{\n        height: 169px;\n        width: 169px;\n    }\n    \n    .homeBtn_container{\n        width: 170px;\n        padding: 30px 0 80px 0;\n    }\n\n    .homeCard1{\n        width: 210px;\n        height: 290px; \n    }\n    \n    .homeCard1h4{\n        font-size: 15px;\n    }\n    \n    .homeCard1p{\n        font-size: 11px;\n        width:180px;\n    }\n\n    .homeCard2{\n        width: 210px;\n        height: 290px; \n    }\n    \n    .homeCard2h4 {\n        font-size: 15px;\n    }\n    \n    .homeCard2p {\n        font-size: 11px;\n        width:180px;\n    }\n\n    .homeSponsorsGallery_icon1{\n        width: 30px;\n        height: 30px;\n    }\n\n    .homeSponsorsGallery_icon{\n        width: 60px;\n        height: 60px;\n    }\n \n    .home_section3_column1p{\n        font-size: 16px;\n    }\n    \n    .homehr_line{\n        width: 150px;\n    \n    }\n    \n    .homeOurThinking_Textp{\n        font-size: 13px;\n        width: 210px;\n\n    }\n    \n    .discovermore_btn{\n        width: 170px;\n        height: 40px;\n    }\n    \n    .homenet1_img_container{\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n    }\n\n    .homenet1_img_container img{\n        width: 750px;\n    }\n\n    .home_section4_container{\n        padding: 70px 20px;\n        gap: 20px\n         \n    }\n    \n    .home_section4_column1h6{\n        font-size: 14px;\n    }\n    \n    .home_section4_column1p{\n        font-size:13px;\n    }\n\n    .home_section4_btn{\n        padding: 8px 24px;\n        width: 130px;\n    }\n    \n    .soluIcon_common{\n        width: 25px;\n        height: 35px;\n    }\n    \n    .solutionsHead_common{\n       font-size: 19px;\n    }\n    \n    .solutionsText_common{\n        font-size: 12px;\n        width: 230px;\n\n    }\n    \n    .solutions_readmore{\n        font-size: 12px;\n    }\n\n    .healthsolu_container{\n        display: flex;\n        width: 260px;\n        height: 181px;\n        gap: 10px;\n    }\n    \n}\n\n\n@media screen and (max-width: 500px){\n\n    .award_container{\n        margin: auto;\n    }\n\n    .home_section1_container{\n        padding: 40px 10px 0 10px;\n    }\n\n    .home_section1_container{\n        height: 670px;\n    }\n\n    .home_section1{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding:30px  30px;\n    }\n    \n     .home_section1_heading h3{\n        font-size: 32px;\n        font-weight: 700;\n        line-height: 65px;\n\n    }\n    \n    .home_section1_heading h5{\n        font-size: 22px;\n        font-weight: 700;\n        line-height: 34px;\n        padding-bottom: 10px;\n\n    }\n    \n    .home_section1_text{\n        width: 380px;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 30px;\n    }\n    \n    .award_container img{\n        height: 179px;\n        width: 179px;\n    }\n\n    .home_section2_container{\n        height: 2500px;\n        padding: 0 20px;\n\n    }\n\n\n    .homeCards_container{\n        display: flex;\n        flex-direction: column;\n        padding-top: 20px;\n    }\n\n    .homeSponsors_container{\n        padding-top:0;\n    }\n\n    .homeCard1{\n        width:100%;\n        height: 350px; \n    }\n    \n    .homeCard1h4{\n        font-size: 24px;\n    }\n    \n    .homeCard1p{\n        font-size: 16px;\n        line-height: 24.46px;\n        text-align: center;\n        width: 300px;\n    }\n    \n    .homeCard2{\n        width:100%;\n        height: 350px;\n    }\n    \n    .homeCard2h4 {\n        font-size: 24px;\n    }\n    \n    .homeCard2p {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        text-align: center;\n        width: 300px;\n    }\n    \n    .homeBtncard_container{\n        width: 180px;\n       padding-top: 50px;\n    }\n\n    .homeSponsors_container{\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .homeSponsorsGallery_container{\n        padding-left: 27rem;\n    }\n\n   \n\n    .home_section3_container{\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: center;\n        align-items: center;\n        margin-top: 0;\n        padding: 20px 0 ;\n        gap: 20px;\n    \n    }\n\n    .home_section3_column1{\n        padding-top: 20px;\n    }\n\n    .home_section3_column1h6{\n        font-size: 15px;\n    }\n\n    .home_section3_column1p{\n        font-size: 24px;\n    }\n\n    .homehr_line{\n        width: 251px;\n        margin-top: 0;\n    }\n\n    .home_section3_column2{\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        width: 100%;\n    }\n\n    .homeOurThinking_Pics img{\n        width: 100%;\n    }\n\n\n    .homeOurThinking_Text{\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n    }\n\n    .homeOurThinking_Textp{\n        font-size: 18px;\n        line-height: 27.52px;\n        width: 339px;\n        height: 196px;\n        text-align: center;\n        padding-top: 10px;\n    }\n\n    .discovermore_btn{\n        width: 200px;\n        height: 52px;\n        margin: auto;\n    }\n\n    .homenet1_img_container{\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n    }\n\n    .homenet1_img_container img{\n        width: 100%;\n    }\n\n    .home_section4_container{\n        height: 1500px;\n        display: flex;\n        flex-direction: column;\n        padding: 40px 20px;\n        gap: 30px;\n        background-color: rgb(5, 53, 5);\n         \n    }\n    .home_section4_column1{\n        width: 100%;\n        height: 154px;\n    }\n    \n    .home_section4_column1h6{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        color: #EAAD11;\n    }\n    \n    .home_section4_column1p{\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        padding-bottom: 20px;\n    }\n\n    .home_section4_hrline{\n        width: 170px;\n    }\n    \n    .home_section4_btn{\n        background-color: #5CBF14;\n        border-radius: 25px;\n        padding: 12px 44px;\n        cursor: pointer;\n        width: 200px;\n        margin-top: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    \n    }\n    \n    .home_section4_btn_p{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n    }\n    \n    .home_section4_column2{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        margin-top: 50px;\n    }\n    .home_section4_column2_part1, .home_section4_column2_part2{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        width: 100%;\n        \n    }\n    \n    .soluIcon_common{\n        width: 40.18px;\n        height: 35.18px;\n    }\n    \n    .solutionsHead_common{\n        font-weight: 700;\n       font-size: 24px;\n       line-height: 33.1px;\n    }\n    \n    .solutionsText_common{\n        font-weight: 400px;\n        font-size: 16px;\n        line-height: 24.46px;\n        width: 100%;\n        height: 96px;\n    }\n    \n    .solutions_readmore{\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 24.46px;\n        color: #EAAD11;\n        width: 78px;\n        /* height: 24px; */\n        padding-top: 10px;\n    }\n    \n    .healthsolu_container{\n        display: flex;\n        width: 100%;\n        height: 181px;\n        gap: 10px;\n    }\n    \n\n    \n}\n\n@media screen and (max-width: 440px){\n    .home_section1{\n        padding:30px  20px;\n    }\n\n    .home_section1_heading h3{\n        font-size: 25px;\n    }\n    \n    .home_section1_heading h5{\n        font-size: 19px;\n        font-weight: 700;\n        line-height: 34px;\n    }\n    \n    .home_section1_text{\n        font-size: 14px;\n        width: 300px;\n    }\n\n\n    .homeOurThinking_Textp{\n        font-size: 16px;\n        width: 300px;\n    }\n\n\n    .home_section4_column1h6{\n        font-size: 15px;\n    }\n    \n    .home_section4_column1p{\n        font-size: 20px;\n    }\n    \n    .home_section4_btn{\n        padding: 10px 32px;\n        width: 190px;\n    }\n    \n    .home_section4_btn_p{\n        font-size: 14px;\n    }\n\n    .home_section4_column2{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        margin-top: 50px;\n    }\n    .home_section4_column2_part1, .home_section4_column2_part2{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        \n    }\n    \n    \n    .soluIcon_common{\n        width: 30.18px;\n        height: 33.18px;\n    }\n    \n    .solutionsHead_common{\n       font-size: 20px;\n    }\n    \n    .solutionsText_common{\n        font-size: 12px;\n    }\n    \n    .solutions_readmore{\n        font-size: 14px;\n    }\n    \n\n\n   \n}\n\n@media screen and (max-width: 380px){\n  \n\n    .home_section1_heading h3{\n        font-size: 20px;\n    }\n    \n    .home_section1_heading h5{\n        font-size: 15px;\n        font-weight: 700;\n        line-height: 34px;\n    }\n    \n    .home_section1_text{\n        width: 310px;\n        font-size: 12px;\n    }\n\n    .home_section2_container{\n        height: 2430px;\n    }\n\n    .homeCard1h4, .homeCard2h4{\n        font-size: 22px;\n    }\n    \n    .homeCard1p, .homeCard2p{\n        font-size: 14px;\n        line-height: 24.46px;\n        text-align: center;\n        width: 240px;\n    }\n\n    .homeSponsorsGallery_container{\n        padding-left: 31rem;\n    }\n\n\n    .home_section3_column1h6{\n        font-size: 12px;\n    }\n\n    .home_section3_column1p{\n        font-size: 22px;\n    }\n\n    .homehr_line{\n        width: 221px;\n        margin-top: 0;\n    }\n\n    \n}\n\n@media screen and (max-width: 330px){\n  \n    .home_section1{\n        padding:30px  10px;\n    }\n    .home_section1_heading h3{\n        font-size: 17px;\n    }\n    \n    .home_section1_heading h5{\n        font-size: 12px;\n        font-weight: 700;\n        line-height: 34px;\n    }\n    \n    .home_section1_text{\n        width: 280px;\n        font-size: 10px;\n    }\n\n    .homeCard1h4, .homeCard2h4{\n        font-size: 20px;\n    }\n    \n    .homeCard1p, .homeCard2p{\n        font-size: 13px;\n        line-height: 24.46px;\n        text-align: center;\n        width: 200px;\n    }\n\n    .homeSponsorsGallery_container{\n        padding-left: 31rem;\n        width: 100%;\n        \n        \n    }\n\n\n    .home_section3_column1h6{\n        font-size: 11px;\n    }\n\n    .home_section3_column1p{\n        font-size: 19px;\n    }\n\n    .homehr_line{\n        width: 200px;\n        margin-top: 0;\n    }\n\n    .homeOurThinking_Textp{\n        font-size: 15px;\n        width: 260px;\n    }\n\n    .discovermore_btn{\n        width: 190px;\n        height: 52px;\n        margin: auto 30px auto ;\n    }\n    \n    .home_section4_btn{\n        padding: 10px 32px;\n        width: 170px;\n    }\n    \n    .home_section4_btn_p{\n        font-size: 12px;\n    }\n    \n    \n    .soluIcon_common{\n        width: 28.18px;\n        height: 30.18px;\n    }\n    \n    .solutionsHead_common{\n       font-size: 18px;\n    }\n    \n    .solutionsText_common{\n        font-size: 12px;\n        margin-bottom: 10px;\n        \n    }\n    \n    .solutions_readmore{\n        font-size: 12px;\n    }\n    \n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
